import ReactDOM from 'react-dom'
import './index.css'
import './commonStyle/font.css'
import '@mobiscroll/react/dist/css/mobiscroll.react.min.css'
import { initSentry } from './lib/sentry'
import App from './dashApp'
import * as serviceWorker from './serviceWorker'

initSentry()

// app root check
ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
